// Components
import getIcon from "utils/getIcon";
// Styles
import styles from "components/molecules/PageTitle/pageTitle.module.css";

type PageTitleProps = {
	showBackIcon?: boolean;
	title: string;
	subTitle: string;
	goBack?: () => void;
};

const PageTitle = ({ showBackIcon, title, subTitle, goBack }: PageTitleProps) => {
	return (
		<>
			<div className={styles?.navigation_wrapper}>
				{showBackIcon && (
					<div className={styles?.header_back_btn} onClick={goBack}>
						{getIcon({ icon: "goBack" })}
					</div>
				)}
				<div className={`${showBackIcon ? styles?.header_wrapper : ""}`}>
					<h1 className={styles?.navigation_header}>{title}</h1>
					<h2 className={styles?.navigation_subheader}>{subTitle}</h2>
				</div>
			</div>
		</>
	);
};

export default PageTitle;
